const MAXIMUM_YEAR_LENGTH = 4;
const CONSTRAINED_INPUT_TYPES = ['date', 'datetime-local'];

document.addEventListener('input', function (event) {
  const input = event.target;

  if (!CONSTRAINED_INPUT_TYPES.includes(input.type) || !input.value) return;

  const [year, ...remainingParts] = input.value.split('-');

  if (year.length <= MAXIMUM_YEAR_LENGTH) return;

  input.value = [year.slice(0, MAXIMUM_YEAR_LENGTH), ...remainingParts].join('-');
});
